import React, { useState, useEffect } from 'react';
import { getMySubjects, uploadContent } from '../../api';
import { toast } from 'react-toastify';

const SubjectContent = () => {
  const [subjects, setSubjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    title: '', description: '', subject_id: '', content_type: 'notes'
  });

  useEffect(() => { loadSubjects(); }, []);

  const loadSubjects = async () => {
    try {
      const res = await getMySubjects();
      setSubjects(res.data);
    } catch (err) {
      toast.error('Error loading subjects');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.keys(formData).forEach(k => data.append(k, formData[k]));
      if (file) data.append('file', file);
      await uploadContent(data);
      toast.success('Content uploaded!');
      setShowForm(false);
      setFormData({ title: '', description: '', subject_id: '', content_type: 'notes' });
      setFile(null);
    } catch (err) {
      toast.error('Error uploading content');
    }
  };

  const contentTypes = [
    { value: 'lecture', label: '🎥 Lecture', color: '#cce5ff' },
    { value: 'notes', label: '📄 Notes', color: '#d4edda' },
    { value: 'slides', label: '📊 Slides', color: '#fff3cd' },
    { value: 'video', label: '▶️ Video', color: '#f8d7da' },
    { value: 'other', label: '📁 Other', color: '#e2e3e5' },
  ];

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>📚 Subject Content</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Upload Content
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Upload New Content</h4>
          <form onSubmit={handleSubmit}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Title</label>
                <input style={styles.input} placeholder="Content title"
                  value={formData.title}
                  onChange={e => setFormData({...formData, title: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Subject</label>
                <select style={styles.input} value={formData.subject_id}
                  onChange={e => setFormData({...formData, subject_id: e.target.value})} required>
                  <option value="">Select Subject</option>
                  {subjects.map(s => (
                    <option key={s.id} value={s.id}>{s.name} - {s.class_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Content Type</label>
                <select style={styles.input} value={formData.content_type}
                  onChange={e => setFormData({...formData, content_type: e.target.value})}>
                  {contentTypes.map(ct => (
                    <option key={ct.value} value={ct.value}>{ct.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Description</label>
              <textarea style={styles.textarea} placeholder="Content description..."
                value={formData.description} rows={3}
                onChange={e => setFormData({...formData, description: e.target.value})} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Upload File</label>
              <input type="file" onChange={e => setFile(e.target.files[0])} />
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Upload</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.typesGrid}>
        {contentTypes.map(ct => (
          <div key={ct.value} style={{...styles.typeCard, background: ct.color}}>
            <h3 style={styles.typeLabel}>{ct.label}</h3>
            <p style={styles.typeDesc}>
              Upload {ct.label.split(' ')[1]} files for students
            </p>
          </div>
        ))}
      </div>

      <div style={styles.infoCard}>
        <p style={styles.infoText}>
          📌 Uploaded content will be visible to students in their portal
          under their respective subjects.
        </p>
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a6b3a', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a6b3a', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px', marginBottom: '15px' },
  inputGroup: { marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', resize: 'vertical' },
  btnGroup: { display: 'flex', gap: '10px' },
  typesGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '15px', marginBottom: '20px' },
  typeCard: { borderRadius: '12px', padding: '20px', textAlign: 'center' },
  typeLabel: { margin: '0 0 8px', fontSize: '16px' },
  typeDesc: { margin: 0, fontSize: '12px', color: '#555' },
  infoCard: { background: '#e8f5e9', borderRadius: '12px', padding: '20px' },
  infoText: { color: '#1a6b3a', margin: 0, fontSize: '14px' },
};

export default SubjectContent;